export default __webpack_public_path__ + "static/media/vire.28e41ded.jpeg";